// extracted by mini-css-extract-plugin
module.exports = {"container":"text-area-module__container___JuHBA","label":"text-area-module__label___aCHli","input":"text-area-module__input___SjmyX","error":"text-area-module__error___GmAUl"};